import { memo, useCallback } from 'react';

import { Badge } from '@air/primitive-badge';

import { WorkspaceAgentGuidedVariantSizeRowButton } from '~/components/v2/components/workspace/workspace-agent-panel/components/composer/guided-variants/WorkspaceAgentGuidedVariantSizeRowButton';
import {
  type WorkspaceAgentScaleConstraintSize,
  workspaceAgentScaleOrCropConstraintChannelId,
} from '~/components/v2/components/workspace/workspace-agent-panel/utils/workspaceAgentScaleOrCrop';

const CONSTRAINT_COPY: Record<WorkspaceAgentScaleConstraintSize['by'], { label: string }> = {
  height: { label: 'Height' },
  'long-side': { label: 'Long side' },
  width: { label: 'Width' },
};

export type WorkspaceAgentGuidedVariantScaleConstraintRowProps = {
  constraint: WorkspaceAgentScaleConstraintSize['by'];
  onFocusMode: (constraint: WorkspaceAgentScaleConstraintSize['by']) => void;
};

export const WorkspaceAgentGuidedVariantScaleConstraintRow = memo(
  ({ constraint, onFocusMode }: WorkspaceAgentGuidedVariantScaleConstraintRowProps) => {
    const copy = CONSTRAINT_COPY[constraint];

    const handleClick = useCallback(() => {
      onFocusMode(constraint);
    }, [constraint, onFocusMode]);

    return (
      <WorkspaceAgentGuidedVariantSizeRowButton
        data-size-id={workspaceAgentScaleOrCropConstraintChannelId(constraint)}
        data-testid="WORKSPACE_AGENT_GUIDED_VARIANT_SCALE_CONSTRAINT"
        onClick={handleClick}
      >
        <span className="truncate">{copy.label}</span>
        <Badge color="gray" size="small">
          px
        </Badge>
      </WorkspaceAgentGuidedVariantSizeRowButton>
    );
  },
);

WorkspaceAgentGuidedVariantScaleConstraintRow.displayName = 'WorkspaceAgentGuidedVariantScaleConstraintRow';
